import React from 'react';
import { APP_NAME } from '../../config/constants';

const Footer = () => (
  <div className="nk-footer">
    <div className="nk-footer-wrap">
      <div className="nk-footer-copyright">
        &copy; {new Date().getFullYear()} {APP_NAME}.
      </div>
    </div>
  </div>
);

export default Footer;
